const s = {
  xs: "xs",
  sm: "s",
  md: "m",
  lg: "l",
  xl: "xl"
}, t = {
  none: "0",
  unset: "unset",
  auto: "auto"
}, n = {
  ...s,
  ...t
};
export {
  n as DIMENSIONS_FALLBACK,
  t as FALLBACK_MAP,
  s as SIZE_MAP
};
